import classNames from "classnames";
import React from 'react';
import Icon from "../Icon";

const SingleChangeButton = ({
  onChange = () => {
  },
  desktop = false,
  next = false,
  messages = '',
  ...props
}) => {

  let commonClasses = [
    "bg-white",
    "border",
    "border-gray-300",
    "font-medium",
    "hover:bg-gray-50",
    "inline-flex",
    "items-center",
    "py-2",
    "relative",
    "text-sm"
  ]

  if (desktop && next) {
    commonClasses = [
      ...commonClasses,
      "px-2",
      "text-gray-500",
      "rounded-r-md"
    ]
  } else if (desktop && !next) {
    commonClasses = [
      ...commonClasses,
      "px-2",
      "text-gray-500",
      "rounded-l-md"
    ]
  } else if (!desktop && next) {
    commonClasses = [
      ...commonClasses,
      "ml-3",
      "px-4",
      "rounded-md",
      "text-gray-700"
    ]
  } else if (!desktop && !next) {
    commonClasses = [
      ...commonClasses,
      "px-4",
      "rounded-md",
      "text-gray-700"
    ]
  }

  return (<a
    onClick={onChange}
    href="#"
    className={classNames(commonClasses)}
  >
              <span
                className="sr-only">{messages}</span>
    <Icon icon={[
      "fas",
      next ?
        "angle-right" :
        "angle-left"
    ]}/>
  </a>)
}


export default SingleChangeButton;
